/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { useCampaignModulesData } from 'bundles/campaigns/context/CampaignModulesDataContext';
import HeroBentoModuleRenderer from 'bundles/campaigns/module-renderers/CampaignHeroModuleRenderer/HeroBentoModuleRenderer';
import HeroModuleRenderer from 'bundles/campaigns/module-renderers/CampaignHeroModuleRenderer/HeroModuleRenderer';

export const useShouldShowCampaignHeroModule = () => {
  const { campaignData, loading } = useCampaignModulesData();
  return !!campaignData?.heroModule?.contentDataJson || loading;
};

type Props = {
  showOptimizedHeroBentoModule?: boolean;
};

const styles = {
  heroModuleContainer: css`
    margin-top: calc(var(--cds-spacing-200) * -1);
    padding-bottom: var(--cds-spacing-400);
  `,
};

const CampaignHeroModuleRenderer = ({ showOptimizedHeroBentoModule = false }: Props) => {
  const { campaignData } = useCampaignModulesData();

  if (!useShouldShowCampaignHeroModule()) {
    return null;
  }

  const content = campaignData?.heroModule?.contentDataJson;

  if (content?.__typename === 'PromoTemplateHero') {
    return (
      <div css={styles.heroModuleContainer}>
        <HeroModuleRenderer />
      </div>
    );
  } else if (content?.__typename === 'HeroBentoModule') {
    return <HeroBentoModuleRenderer showOptimization={showOptimizedHeroBentoModule} />;
  }

  return null;
};

export default CampaignHeroModuleRenderer;
